import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Speaking from '../components/Speaking';
import { PageMetadata } from '../components/PageMetadata';

export default function SpeakingPage() {
  return <div className="page-content">
    <PageMetadata title="Speaking & Professional Community | Elena Nurullina" description="Speaking, mentoring, judging, and professional community participation by Elena Nurullina." />
    <div className="container"><Link to="/" className="back-link"><ArrowLeft size={18} aria-hidden="true" />Back to Home</Link></div>
    <Speaking />
  </div>;
}
